import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

let drilldownControllerRef = null;
const getRejectionsCard = async (
  { timeFrame = {}, filters },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/rejections/card`, params);
  return hireCardResponse;
};

const getRejectionsTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(
    `/reports/rejections/chart_table`,
    params
  );
  return hireCardResponse;
};

const getRejectionReasonVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(
    `/reports/rejections/chart_table`,
    params
  );
  return hireCardResponse;
};

const getRejectionStageVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/rejections/visual`, params);
  return hireCardResponse;
};

const getRejectionSourceVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/rejections/visual`, params);
  return hireCardResponse;
};

const getRejectionDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      customFilter,
    });
    const response = await atsHttp.post(
      `/reports/rejections/drilldown`,
      params,
      {
        signal: controller.signal,
      }
    );
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchRejectionsCard = createAsyncThunk(
  'ats-reports/rejections/card',
  getRejectionsCard
);

export const fetchRejectionsTableAndChart = createAsyncThunk(
  'ats-reports/rejections/table-chart',
  getRejectionsTableAndChart
);

export const fetchRejectedReasonVisual = createAsyncThunk(
  'ats-reports/rejections/reason',
  getRejectionReasonVisual
);

export const fetchRejectionStageVisual = createAsyncThunk(
  'ats-reports/rejections/stage/visual',
  getRejectionStageVisual
);

export const fetchRejectionSourceVisual = createAsyncThunk(
  'ats-reports/rejections/source/visual',
  getRejectionSourceVisual
);

export const fetchRejectionDrilldown = createAsyncThunk(
  'ats-reports/rejections/drilldown',
  getRejectionDrilldown
);
